export default "__VITE_ASSET__2Wo72GcI__"